// extracted by mini-css-extract-plugin
export var textInput = "_lb-0";